import React from 'react';
import { Translation } from 'react-i18next';
import ComponentHeader from '../ecap/ComponentHeader';
import CareerCarousel from './utility/CareerCarousel';
import Loading from '../utility/Loading';
import DashboardModal from './DashboardModal';
import ModalController from '../utility/modal/ModalController';
import { getCategoryImages } from '../utility/getCategoryImages';

export default class Favorites extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      lushFavoriteCareerList: [],
    };
  }

  componentDidMount() {
    if (!this.props.location.pathname.includes('user-profile')) {
      this.props.getFavorites(this.props.userId);
    }
    this.updateLushFavorites({
      favorites: {},
    });
  }

  componentDidUpdate(prevProps) {
    this.updateLushFavorites(prevProps);
  }

  updateLushFavorites = (prevProps) => {
    const { allTenantCareers } = this.props.location.pathname.includes(
      'user-profile'
    )
      ? this.props
      : this.props.tenant;
    if (
      (this.props.favorites && prevProps.favorites !== this.props.favorites) ||
      (prevProps.tenant.allTenantCareers !== allTenantCareers &&
        !this.props.location.pathname.includes('user-profile'))
    ) {
      const favoriteCareerList = getCategoryImages(this.props.favorites);
      this.setState({
        lushFavoriteCareerList: favoriteCareerList,
      });
    }
  };

  render() {
    const { lushFavoriteCareerList } = this.state;
    if (this.props.favorites?.length < 1)
      return (
        <Translation>
          {(t) => (
            <div className="dashboard-modal-container">
              <ModalController />
              <ComponentHeader
                parent="dashboard"
                headerText={
                  this.props.location.pathname.includes('user-profile')
                    ? t('Favorite Careers')
                    : t('My Favorite Careers')
                }
                tenant={this.props.tenant}
              />
              <DashboardModal
                tenant={this.props.tenant}
                location={this.props.location}
              />
            </div>
          )}
        </Translation>
      );
    return (
      <Translation>
        {(t) => (
          <div id="dashboard-favorites">
            <ComponentHeader
              parent="dashboard"
              headerText={
                this.props.location.pathname.includes('user-profile')
                  ? t('Favorite Careers')
                  : t('My Favorite Careers')
              }
              tenant={this.props.tenant}
            />
            {lushFavoriteCareerList.length > 0 ? (
              <CareerCarousel
                parent="favorites"
                tenant={this.props.tenant}
                careerCardSubText={t('View Details')}
                careerList={lushFavoriteCareerList}
                userProfileFavorites={this.props.favorites}
              />
            ) : (
              <Loading />
            )}
          </div>
        )}
      </Translation>
    );
  }
}
